import { IPoi, Poi } from 'src/app/core/poi/poi.model';

export class PaginatedPoi {
  list: IPoi[];
  size: number;
  page: number;
  total: number;

  static from(obj: any): PaginatedPoi {
    return {
      list: Poi.fromArray(obj.list),
      size: obj.size,
      page: obj.page,
      total: obj.total,
    };
  }
}
